
import { useEffect } from 'react';
import { messaging } from '../../firebase';
import { getToken } from 'firebase/messaging';
import { registerDeviceToken } from '../Notification/services/notificationApi';
import logger from '../../utils/logger';


const vapidKey = process.env.REACT_APP_VAPID_KEY;

const NotificationManager = () => {
  useEffect(() => {
    const requestPermission = async () => {
      try {
        const token = await getToken(messaging, { vapidKey });
        const employeeId = sessionStorage.getItem('employeeId');
        if (token && employeeId) {
          await registerDeviceToken(token, employeeId);
        }
      } catch (err) {
        logger.error('Permission denied or error getting token', err);
      }
    };
    requestPermission();
  }, []);

  return null; // No UI needed
};

export default NotificationManager;
